import PropTypes from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components/macro'

import { Tag, Tooltip } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Icon } from 'core/ui/components/icon/Icon'

import { RequirementLabel } from 'legacy/components/LoadOffer/RequirementLabel'

const Wrapper = styled.section`
  flex-flow: row nowrap;
  flex-shrink: 0;
  align-items: center;
  height: 25.5px;
  padding: 0 5px 0 7px;
  border-radius: 2px;
  display: flex;
  justify-content: space-between;

  > :not(:last-child) {
    margin-right: 5px;
  }
`

const RequirementItem = styled.div`
  display: flex;
  align-items: center;
`

const RequirementItemSeparator = styled.div`
  margin-left: ${getToken('space-xs')};
  margin-right: ${getToken('space-xs')};
  :after {
    content: ' \\B7 ';
    font-size: ${getToken('font-size-1')};
  }
`

function LoadRequirements({ requirements }) {
  const requirementList = useMemo(() => {
    // Checking if there are more than 2 requirements in order to display +N
    if (requirements.length > 2) {
      // Adding new icon with the number of requirements that are not displayed
      return requirements.slice(0, 2).concat([
        {
          type: `+${requirements.length - 2}`,
        },
      ])
    }
    return requirements
  }, [requirements])

  return (
    <Wrapper>
      <Tooltip align="end" message="Requirements">
        <Tag
          leading={<Icon name="attention" width={16} height={16} />}
          size="default"
          variant="warning"
        >
          {requirementList.map((requirement, i) => (
            <RequirementItem key={requirement.type}>
              <RequirementLabel requirement={requirement} />
              {i < requirementList.length - 1 && <RequirementItemSeparator />}
            </RequirementItem>
          ))}
        </Tag>
      </Tooltip>
    </Wrapper>
  )
}

LoadRequirements.propTypes = {
  requirements: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      params: PropTypes.shape({}),
    })
  ).isRequired,
}

export { LoadRequirements }
